module.exports = __webpack_public_path__ + "img/pain-spot-12.527b66db.svg";